export interface SpecialRestrictionsReturnToNormalActivity{
    hasSpecialRestrictions: boolean,
    specialRestrictionsDetails: string,
}

export const defaultSpecialRestrictionsReturnToNormalActivity: SpecialRestrictionsReturnToNormalActivity = {
    hasSpecialRestrictions: false,
    specialRestrictionsDetails: ""
} 